import "@/App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import ScrollToTop from "./components/common/ScrollToTop";

// Pages
import HomePage from "./pages/HomePage";
import RessourcesPage from "./pages/RessourcesPage";
import RemembrementForestierPage from "./pages/RemembrementForestierPage";
import VendreParcelleBoisPage from "./pages/VendreParcelleBoisPage";
import MorcellementForestierPage from "./pages/MorcellementForestierPage";
import TransactionsForestiersPage from "./pages/TransactionsForestiersPage";
import SuccessionsForestiersPage from "./pages/SuccessionsForestiersPage";
import EstimationForetPage from "./pages/EstimationForetPage";
import VendreBoisSurPiedPage from "./pages/VendreBoisSurPiedPage";
import PolitiqueConfidentialitePage from "./pages/PolitiqueConfidentialitePage";
import NotFoundPage from "./pages/NotFoundPage";

// Main App Component
function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/ressources" element={<RessourcesPage />} />
          <Route path="/remembrement-forestier" element={<RemembrementForestierPage />} />
          <Route path="/vendre-parcelle-bois" element={<VendreParcelleBoisPage />} />
          <Route path="/morcellement-forestier" element={<MorcellementForestierPage />} />
          <Route path="/transactions-forestieres" element={<TransactionsForestiersPage />} />
          <Route path="/successions-forestieres" element={<SuccessionsForestiersPage />} />
          <Route path="/estimation-foret" element={<EstimationForetPage />} />
          <Route path="/vendre-bois-sur-pied" element={<VendreBoisSurPiedPage />} />
          <Route path="/politique-confidentialite" element={<PolitiqueConfidentialitePage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
